<script setup lang="ts">
import { computed } from "vue";
import { ToastDescription, ToastRoot, ToastTitle } from "reka-ui";
import { cn } from "@/lib/utils";

// shadcn-vue Toast, themed to brand tokens. The kill-switch result is the
// Console's only toast use (REQ-CD-P1-CON-05) and is announced through
// aria-live="assertive" per REQ-CD-P1-CON-07, since it reports a state change
// the operator deliberately caused.
const props = defineProps<{ open: boolean; title: string; description?: string; variant?: "default" | "error" }>();
const emit = defineEmits<{ "update:open": [boolean] }>();

const classes = computed(() =>
  cn(
    "rounded-lg border bg-card p-4 shadow-xl",
    props.variant === "error" ? "border-status-error/60" : "border-status-ok/60",
  ),
);
</script>

<template>
  <ToastRoot
    :open="open"
    :class="classes"
    role="status"
    aria-live="assertive"
    @update:open="emit('update:open', $event)"
  >
    <ToastTitle class="text-sm font-semibold text-slate-100">{{ title }}</ToastTitle>
    <ToastDescription v-if="description" class="mt-1 text-xs text-brand-light">
      {{ description }}
    </ToastDescription>
  </ToastRoot>
</template>
